<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; dislay: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <div class="CIT_background">
        <div class="position">
          <step-progress
            :steps="mySteps"
            :current-step="currentStep"
            icon-class="fa fa-check fa-lg"
          ></step-progress>
          <div class="card_QZ01">
            <div class="block">
              <CRow class="title">
                <CCol col="12" style="display: flex; justify-content: center">
                  <div :class="checkLangClass()">
                    <div class="title_text">
                      {{ checkLanguage(title) }}
                    </div>
                  </div>
                </CCol>
              </CRow>
            </div>
            <div class="container_pw01">
              <div class="list_card">
                <div
                  v-for="(key, value) in image"
                  :key="value"
                  style="position: relative"
                  @click="handle_image(value)"
                >
                  <div class="card cardUnactive" :id="value">
                    <img
                      :src="'https://mdl.mfu.ac.th/' + image[value].item.data"
                      class="img_card_component"
                    />
                  </div>

                  <div class="title_box">
                    <h1 style="text-align: center">
                      {{ returnChoiceText(value + 1) }}
                    </h1>
                  </div>
                </div>
              </div>
              <div class="button_setting">
                <div
                  class="container_checkbox"
                  @click="setAnswer(0, questionChoice[0])"
                >
                  <div class="checkbox">
                    <a style="font-size: 2.5rem; font-weight: bold">{{
                      answer0
                    }}</a>
                  </div>
                  <div class="fontChinese text_checkbox font_checkbox">
                    {{ questionChoice[0] }}
                  </div>
                </div>
                <div
                  class="container_checkbox"
                  @click="setAnswer(1, questionChoice[1])"
                >
                  <div class="checkbox">
                    <a style="font-size: 2.5rem; font-weight: bold">{{
                      answer1
                    }}</a>
                  </div>
                  <div class="fontChinese text_checkbox font_checkbox">
                    {{ questionChoice[1] }}
                  </div>
                </div>
                <div
                  class="container_checkbox"
                  @click="setAnswer(2, questionChoice[2])"
                >
                  <div class="checkbox">
                    <a style="font-size: 2.5rem; font-weight: bold">{{
                      answer2
                    }}</a>
                  </div>
                  <div class="fontChinese text_checkbox font_checkbox">
                    {{ questionChoice[2] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="menu_btn">
            <div class="icon_arrow" @click="onPrev">
              <div :class="checkDisableBtn('btn')">
                <div :class="checkDisableBtn('font')">
                  <b>PREVIOUS</b>
                </div>
              </div>
            </div>
            <div class="icon_arrowright">
              <div class="arrow_right" @click="submit_ans">
                <div class="font_next">
                  <b>NEXT</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CheckBox from "@/components/elements/Checkbox/Checkbox";
import Card from "@/components/elements/Card";
import LoadingMDL from "@/components/loading/LoadingMDL";
import { mapGetters } from "vuex";
import StepProgress from "vue-step-progress";
import "vue-step-progress/dist/main.css";
import "../../assets/scss/chinessStyle2.scss";

export default {
  components: { CheckBox, Card, LoadingMDL, StepProgress },
  name: "PW01",
  props: {},
  data() {
    return {
      content: [],
      language: this.$store.getters["language/getLanguage"],
      image: [],
      loading: true,
      questionChoice: [],
      answer: "",
      answer0: "",
      answer1: "",
      answer2: "",
      answerData: [],
      navigate: [],
      templateData: {},
      condition: [],
      startTime: this.$helpers.getDateFormat(),
      mySteps: [],
      currentStep: null,
      title: [
        {
          key: "th",
          value: "กรุณาจับคู่คำศัพท์ด้านล่างนี้",
        },
        {
          key: "cn",
          value: "请选择对应的答案",
        },
        {
          key: "en",
          value: "Please put the words in the correct order.",
        },
      ],
      code:"",
      section:"",
    };
  },
  methods: {
    handle_image: function (val) {
      if (document.getElementById(val).classList == "card cardUnactive") {
        switch (val) {
          case 0:
            document.getElementById(0).className = "";
            document.getElementById(1).className = "card cardUnactive";
            document.getElementById(2).className = "card cardUnactive";
            document.getElementById(0).classList.add("cardActive", "card");
            this.answer = this.returnChoiceText(val + 1);
            break;
          case 1:
            document.getElementById(1).className = "";
            document.getElementById(0).className = "card cardUnactive";
            document.getElementById(2).className = "card cardUnactive";
            document.getElementById(1).classList.add("cardActive", "card");
            this.answer = this.returnChoiceText(val + 1);
            break;
          case 2:
            document.getElementById(2).className = "";
            document.getElementById(0).className = "card cardUnactive";
            document.getElementById(1).className = "card cardUnactive";
            document.getElementById(2).classList.add("cardActive", "card");
            this.answer = this.returnChoiceText(val + 1);
            break;
        }
      } else if (document.getElementById(val).classList == "cardActive card") {
        document.getElementById(val).classList.remove("cardActive");
        document.getElementById(val).classList.add("cardUnactive");
        this.answer = "";
      }
    },
    checkDisableBtn: function (type) {
      if (type == "btn") {
        if (this.navigate.previous.action != null) {
          return "arrow_left";
        } else {
          return "arrow_left_disable";
        }
      } else if (type == "font") {
        if (this.navigate.previous.action != null) {
          return "font_prev";
        } else {
          return "font_prev_disable";
        }
      }
    },
    onPrev: function () {
      if (this.navigate.previous.action == null) {
        alert("Can not go back!");
      } else {
        let prevPath = this.navigate.previous.action.split("-");
        if (prevPath[0] == "QZ01") {
          this.loading = true;
          this.answer0 = "";
          this.answer1 = "";
          this.answer2 = "";
          this.image = [];
          this.content = [];
          this.answer = "";
          this.questionChoice = [];
          this.answerData = [];
          this.navigate = [];
          let payload = {
            templateCode: prevPath[0] + "-" + prevPath[1],
          };
          this.$store.dispatch("template/fetchTestTemplate", payload);
          this.$router.push("/" + prevPath[0] + "/" + prevPath[1]);
        } else {
          this.$router.push("/" + prevPath[0] + "/" + prevPath[1]);
        }
      }
    },
    submit_ans: function () {
      let countScore = 0;
      let isCompleted = true;

      for (let k = 0; k < 3; k++) {
        if (this.answerData[k] == undefined) {
          isCompleted = false;
        }
      }

      if (!isCompleted) {
        alert("please fill in the answer");
      } else {
        for (let i = 0; i < this.answerData.length; i++) {
          for (let j = 0; j < this.content.item.length; j++) {
            if (this.content.item[j].order == i + 1) {
              if (
                this.answerData[i] == this.content.item[j].choices[0].question
              ) {
                countScore += 1;
              }
            }
          }
        }

        let store = [];
        let dataLength = this.templateData.templateData.content.item.length;
        for (let index = 0; index < dataLength; index++) {
          store.push({
            match: this.templateData.templateData.content.item[index].item.data,
            answer: this.answerData[index],
            index: this.templateData.templateData.content.item[index].order,
          });
        }

        this.$store.dispatch("template/commitUserProgressChinese2", {
          // code: "605418cb883ae722ba1b0c5f",
          code: this.code,
          codeTemplate: this.templateData.templateData.codeTemplate,
          contentId: this.templateData.criteria._id,
          answering: store,
          startTime: this.startTime,
          endTime: this.$helpers.getDateFormat(),
          condition: this.condition,
          chapter:
            this.templateData.chapter == undefined
              ? null
              : this.templateData.chapter,
          topic: this.templateData.topicPosition,
        });
        this.loading = true;
      }
    },
    checkLanguage(val) {
      if (val) {
        try {
          for (let i = 0; i <= val.length; i++) {
            if (val[i].key != null) {
              if (val[i].key.toUpperCase() == this.language) {
                return val[i].value;
              }
            }
          }
        } catch (err) {
          console.log("change language is error 1!!");
        }
      } else {
        console.log("change language is error 2!!");
      }
    },
    checkLangClass() {
      if (this.language == "CN") {
        return "fontChinese";
      } else if (this.language == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    returnChoiceText: function (index) {
      if (index == 1) {
        return "A";
      } else if (index == 2) {
        return "B";
      } else if (index == 3) {
        return "C";
      } else {
        return "Error";
      }
    },
    returnChoiceNumber: function (text) {
      if (text == "A") {
        return 0;
      } else if (text == "B") {
        return 1;
      } else if (text == "C") {
        return 2;
      }
    },
    setAnswer(index, data) {
      if (this.answer == "") {
        alert("please select image first");
      } else {
        for (let i = 0; i < 3; i++) {
          if (this.answerData[i] == data) {
            this.answerData[i] = undefined;
          }
        }
        switch (index) {
          case 0:
            for (let index = 0; index < 3; index++) {
              if (this.answer0 == this.answer) this.answer0 = "";
              if (this.answer1 == this.answer) this.answer1 = "";
              if (this.answer2 == this.answer) this.answer2 = "";
            }
            this.answerData[this.returnChoiceNumber(this.answer)] = data;
            this.answer0 = this.answer;
            break;
          case 1:
            for (let index = 0; index < 3; index++) {
              if (this.answer0 == this.answer) this.answer0 = "";
              if (this.answer1 == this.answer) this.answer1 = "";
              if (this.answer2 == this.answer) this.answer2 = "";
            }
            this.answerData[this.returnChoiceNumber(this.answer)] = data;
            this.answer1 = this.answer;
            break;
          case 2:
            for (let index = 0; index < 3; index++) {
              if (this.answer0 == this.answer) this.answer0 = "";
              if (this.answer1 == this.answer) this.answer1 = "";
              if (this.answer2 == this.answer) this.answer2 = "";
            }
            this.answerData[this.returnChoiceNumber(this.answer)] = data;
            this.answer2 = this.answer;
            break;
        }
      }
    },
    setProgress: function (value) {
      return new Promise((resolve, reject) => {
        value.chapter.item.map((i) => {
          switch (i.content.type) {
            case "topic":
              this.mySteps.push("Topic");
              break;
            case "flipcard":
              this.mySteps.push("Vocabulary");
              break;
            case "assignment":
              this.mySteps.push("Assignment");
              break;
            case "test":
              this.mySteps.push("Test");
              break;
            default:
              this.mySteps.push(i.content.type);
              break;
          }
        });
        // value.checkPoints.map((i) => {
        //   if (i._id.topic == value.topicPosition.codeItem) {

        //   }
        // });
        this.currentStep = value.topicPosition.index - 1;
        resolve();
      });
    },
  },
  computed: {
    ...mapGetters({
      getTemplateAndProgress: "template/getTemplateAndProgress",
      getResponseStatus: "template/getResponseStatus",
      storeLanguage: "language/getLanguage",
    }),
  },
  watch: {
    getTemplateAndProgress: async function (value) {
      this.mySteps = [];
      this.templateData = value;
      if (value.criteria.condition.criteriaType.length != 0) {
        this.condition.push({
          criteria: value.criteria.condition.criteriaType[0]._id,
          val: value.criteria.condition.criteriaType[0].val,
        });
      }
      this.content = value.templateData.content;
      this.navigate = value.templateData.navigate;
      let store = [];
      value.templateData.content.item.forEach((el) => {
        store.push(el.choices[0].question);
      });
      this.questionChoice = store.sort(() => Math.random() - 0.5);
      this.image = value.templateData.content.item;
      await this.setProgress(value);
      this.loading = false;
    },
    getResponseStatus: async function (value) {
      if (value.status == 200) {
        let nextPath = this.navigate.next.action.split("-");
        if (nextPath[0] == "QZ01") {
          this.loading = true;
          this.answer0 = "";
          this.answer1 = "";
          this.answer2 = "";
          this.image = [];
          this.content = [];
          this.answer = "";
          this.mySteps = [];
          this.currentStep = null;
          this.questionChoice = [];
          this.answerData = [];
          this.navigate = [];

          let payload = {
            templateCode: nextPath[0] + "-" + nextPath[1],
            // code: "605418cb883ae722ba1b0c5f",
            code:this.code,
            // section: "testing",
            section:this.section
          };
          this.$store.dispatch("template/fetchTemplateAndProgress", payload);
          this.$router.push("/" + nextPath[0] + "/" + nextPath[1]);
        } else {
          this.$router.push("/" + nextPath[0] + "/" + nextPath[1]);
        }
      }
    },
    storeLanguage: function (value) {
      this.language = value;
    },
  },
  created() {
    this.currentRoute = this.$route.name + "-" + this.$route.params.id;
    this.courseData = this.$store.getters["necessary/getLerningCourse"]
    this.code = this.courseData._id;
    this.section = this.$store.getters['necessary/getUserCourseSection']
    console.log(this.section);
  },
  mounted() {
    this.language = this.$store.getters["language/getLanguage"];
    let payload = {
      templateCode: this.currentRoute,
      // code: "605418cb883ae722ba1b0c5f",
      code:this.code,
      // section: "testing",
      section:this.section
    };
    this.$store.dispatch("template/fetchTemplateAndProgress", payload);
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
::v-deep .step-progress__wrapper {
  width: 95%;
}
::v-deep .step-progress__wrapper-before {
  top: 45%;
  height: 10px;
  opacity: 0.5;
  background-color: #3b3b38 !important;
}

::v-deep .step-progress__step--valid:after {
  background-color: #1d5bd7;
}
::v-deep .step-progress__step--valid:after {
  border: #1d5bd7 solid !important;
}
::v-deep .step-progress__step--active:after {
  border: #1d5bd7 solid !important;
}
::v-deep .step-progress__step--active .step-progress__step-label,
.step-progress__step--active span {
  color: #1d5bd7;
}
::v-deep .step-progress__wrapper-after {
  top: 45%;
  height: 10px;
  background-color: #1d5bd7 !important;
  opacity: 0.5;
}
::v-deep .step-progress__step span {
  font-size: 0px;
}
::v-deep svg:not(:root).svg-inline--fa {
  width: 20px;
  height: 20px;
}
::v-deep .step-progress__step-label {
  top: -50px;
}
::v-deep .step-progress__step--valid .step-progress__step-label {
  color: #1d5bd7;
}
::v-deep .step-progress__step:after {
  width: 40px;
  height: 40px;
  border: #808080 solid;
}
::v-deep .step-progress__bar {
  margin-bottom: 10px;
  height: 6s0px;
}
.block {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: #e6efff;
  width: 95%;
  height: 70px;
  border-radius: 7px;
}
.title_text {
  margin-bottom: 0;
  font-size: 20px;
}

.icon_arrow {
  margin-right: 10%;
  margin-top: 5%;
}
.icon_arrowright {
  margin-left: 10%;
  margin-top: 5%;
}
.title_box {
  width: 50px;
  height: 50px;
  border: 5px solid #1d5bd7;
  border-radius: 10px;
  left: 5%;
  bottom: 3%;
  background-color: #e6efff;
  position: absolute;
}
.menu_btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.arrow_left {
  width: 150px;
  height: 50px;
  background-color: #e6efff;
  cursor: pointer;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.arrow_left_disable {
  width: 150px;
  height: 50px;
  border-radius: 10px;
  background-color: #e6efff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.arrow_right {
  width: 150px;
  height: 50px;
  border-radius: 10px;
  background-color: #1d5bd7;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.CIT_background {
  background-color: #ffdc77;
  padding-top: 7%;
  padding-bottom: 10%;
  display: flex;
  align-content: center;
  justify-content: center;
}
.font_prev {
  color: #1d5bd7;
  font-size: 20px;
}
.font_prev_disable {
  color: #1d5bd7;
  font-size: 20px;
}
.font_next {
  color: white;
  font-size: 20px;
}
.position {
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
}
.card_QZ01 {
  background-color: white;
  width: 1000px;
  height: 600px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 20px; /* 5px rounded corners */
  padding-top: 20px;
}
.card {
  border-radius: 20px; /* 5px rounded corners */
  border: 0px solid;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}

.container_checkbox {
  background-color: #e6efff;
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  border-radius: 15px;
}
.size_image {
  width: 50%;
  height: 50%;
}

.checkbox {
  width: 20%;
  height: 75%;
  display: flex !important;
  justify-content: center !important;
  align-items: center;
  border: 3.5px solid;
  border-radius: 10px;
  margin-left: 15px;
  margin-right: 25px;
}
.text_checkbox {
  font-size: 34px !important;
  width: 70%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.cardUnactive {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  width: 90%;
  height: 100%;
  border-radius: 15px;
}
.cardActive {
  // margin: 0;
  width: 90%;
  height: 100%;
  border-radius: 15px;
  border: 6px groove;
  border-color: #1d5bd7;
}
.img_card_component {
  width: 100%;
  height: 100%;
}
.container_pw01 {
  margin-top: 2%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.container_checkbox {
  margin-left: 10px;
  margin-right: 10px;
  height: 70px;
  margin-bottom: 20px;
}
.button_setting {
  display: flex;
  justify-content: center;
  color: #1d5bd7;
  text-align: center;
  cursor: pointer;
  font-size: 15px;
  border-radius: 15px !important;
  padding: 20px;
  margin-top: 20px;
  width: 100%;
}

.list_card {
  display: flex;
  justify-content: center;
  cursor: pointer;
  margin-left: 27px;
}
.ContentProgressBar {
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  width: 97%;
  padding: 10px 10px 10px 10px;
  .ProgressBar {
    background-color: #e6efff !important;
    margin-top: 3%;
    width: 100%;
    height: 10px;
    border-radius: 10px !important;
  }
}
* {
  user-select: none;
}
.progress-bar-striped {
  background-image: none !important;
}
@media only screen and (min-width: 300px) and (max-width: 600px) {
  ::v-deep .step-progress__wrapper {
    width: 80%;
  }
  .title_box {
    width: 30px;
    height: 30px;
    top: 50%;
    left: 15%;
  }
  .block {
    margin-top: 5px;
    margin-bottom: 10px;
  }
  .title {
    width: 92%;
  }
  .font_prev_disable {
    color: #1d5bd7;
    font-size: 16px;
  }
  .font_next {
    font-size: 16px;
  }
  h1 {
    font-size: 15px;
  }
  .container_pw01 {
    flex-direction: row;
  }
  .list_card {
    flex-direction: column;
    margin-left: 20px;
  }
  .button_setting {
    flex-direction: column;
    margin-top: 0;
    padding: 0px 20px 0px 20px;
  }
  .card_QZ01 {
    width: 300px;
    height: auto;
  }
  .CIT_background {
    padding-top: 22%;
  }
  .card {
    width: 150px;
    height: 150px;
  }
  .icon_arrow {
    height: auto;
  }
  .icon_arrowright {
    height: auto;
  }
  .container_checkbox {
    height: 100%;
  }
  .checkbox {
    width: 40%;
    height: 30%;
    margin-left: 10px;
    margin-right: 15px;
  }
  .arrow_left {
    width: 100px;
    height: 50px;
    border-radius: 10px;
  }
  .arrow_left_disable {
    width: 100px;
    height: 50px;
    border-radius: 10px;
  }
  .arrow_right {
    width: 100px;
    height: 50px;
    border-radius: 10px;
  }
  .cardUnactive {
    height: auto;
  }
  .cardActive {
    height: auto;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .position {
    padding-top: 15%;
  }
  .card_QZ01 {
    width: 700px;
    height: 500px;
  }
  .ContentProgressBar {
    width: 98%;
  }
  ::v-deep .step-progress__wrapper {
    width: 90%;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1279px) {
  .card_QZ01 {
    height: auto;
  }
  .icon_arrow {
    height: auto;
    margin-right: 3%;
  }
  .icon_arrowright {
    height: auto;
    margin-left: 3%;
  }
}
@media only screen and (min-width: 1280px) and (max-width: 1367px) {
  .card_QZ01 {
    width: 800px;
    height: auto;
  }
}
@media only screen and (min-width: 1600px) and (max-width: 1920px) {
  .ContentProgressBar {
    width: 100%;
    padding-left: 30px;
    padding-right: 30px;
  }

  .container_CIT01 {
    width: 100%;
  }
}
</style>
